/* eslint-disable */
import { languageTag } from "../../runtime.js"
import * as en from "../en/unlock_code_product_limit.js"
import * as nl from "../nl/unlock_code_product_limit.js"
import * as de from "../de/unlock_code_product_limit.js"


/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ currentProductCount: NonNullable<unknown>, maxProducts: NonNullable<unknown> }} params
 * @param {{ languageTag?: "en" | "nl" | "de" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const unlock_code_product_limit = (params , options = {}) => {
	return {
		de: de.unlock_code_product_limit,
		en: en.unlock_code_product_limit,
		nl: nl.unlock_code_product_limit
	}[options.languageTag ?? languageTag()](params)
}

